<template>
  <div id="slideCheck">
    <i @click="$emit('close')"></i>
    <h3>安全验证</h3>
    <img src="/static/images/login/icon_slideCheck.png" alt="" />
    <p>{{ errText }}</p>
    <div id="slideCheck-box"></div>
  </div>
</template>

<script>
export default {
  props: {
    errText: {
      default: '为了保证账号安全，正常登录，请进行滑动验证',
    },
  },
  data() {
    return {}
  },
  mounted() {
    window.initAliyunCaptcha({
      immediate: true,
      SceneId: 'scwrirwr', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: '4gaarz', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#slideCheck-box', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      onError: (err) => {
        this.$emit('check', err)
      },
      slideStyle: {
        width: 320,
        height: 36,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    })
    // 实例化nc

    // const scene = 'nc_message_h5' // 炳成无法提供，暂时使用菊姐给的
    // window.AWSC.use('nc', (state, module) => {
    //   // 初始化
    //   this.nc = module.init({
    //     // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
    //     appkey: 'FFFF0N00000000009EF7',
    //     // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
    //     scene: scene,
    //     // 声明滑动验证需要渲染的目标ID。
    //     renderTo: 'slideCheck-box',
    //     // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
    //     success: (data) => {
    //       this.$emit('check', {
    //         scene,
    //         sessionId: data.sessionId,
    //         sig: data.sig,
    //         token: data.token,
    //       })
    //     },
    //     // 滑动验证失败时触发该回调参数。
    //     fail: (failCode) => {
    //       this.$emit('check', failCode)
    //       console.info('failCode', failCode)
    //     },
    //     // 验证码加载出现异常时触发该回调参数。
    //     error: (errorCode) => {
    //       this.$emit('check', errorCode)
    //       console.info('errorCode', errorCode)
    //     },
    //   })
    // })
  },
  methods: {
    getInstance(instance) {
      this.captcha = instance
    },
    captchaVerifyCallback(res, call) {
      this.$emit('check', {
        data: Object.assign({ nvVersion: '2.0' }, JSON.parse(res)),
        call: () => {
          call({
            captchaResult: true,
          })
        },
      })
    },
    onBizResultCallback() {
      console.log(2)
    },
    reset() {
      this.captcha && this.captcha.refresh()
      // this.nc.reset()
    },
  },
}
</script>

<style lang="less">
#slideCheck {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  i {
    position: absolute;
    top: 20px;
    left: 50%;
    margin-left: 136px;
    display: block;
    width: 24px;
    height: 24px;
    background: url(/static/images/login/icon_close.png);
    cursor: pointer;
  }
  h3 {
    font-size: 18px;
    color: #343434;
    line-height: 24px;
    margin-top: 30px;
  }
  img {
    margin: 34px auto 10px;
  }
  p {
    width: 200px;
    text-align: center;
    font-size: 14px;
    color: #666666;
    line-height: 21px;
  }
  #slideCheck-box {
    position: initial;
    margin-top: 20px;
  }
  .nc_wrapper {
    margin: 0 auto;
  }
  .nc_scale > * {
    height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/slideCheck.vue